import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DefinicaoFormSignature } from "../../../app/shared/Signature/DefinicaoFormSignature";
import { OpcaoFormSignature } from "../../../app/shared/Signature/OpcaoFormSignature";
import { FormService } from "./api-form.service";

@Injectable({
  providedIn: 'root'
})
export class FormDataService {

  constructor(private api: FormService) {
  }

  // Form Definition Methods
  public GetDefinicoesForms(): Observable<any> {
    return this.api.GetDefinicoesForms();
  }

  public GetDefinicoesFormsPorId(id: string): Observable<any> {
    return this.api.GetDefinicoesFormsPorId(id);
  }

  public GetDefinicoesFormPorNome(name: string): Observable<any> {
    return this.api.GetDefinicoesFormPorNome(name);
  }

  public CriarDefinicaoForm(signature: DefinicaoFormSignature): Observable<any> {
    return this.api.CriarDefinicaoForm(signature);
  }

  public AtualizarDefinicaoForm(signature: DefinicaoFormSignature): Observable<any> {
    return this.api.AtualizarDefinicaoForm(signature);
  }

  public DeletarDefinicaoForm(id: string): Observable<any> {
    return this.api.DeletarDefinicaoForm(id);
  }

  // Form Option Methods
  public GetOpcoesForm(formId: string): Observable<any> {
    return this.api.GetOpcoesForm(formId);
  }

  public GetOpcaoFormPorId(id: string): Observable<any> {
    return this.api.GetOpcaoFormPorId(id);
  }

  public GetDefinicoesFormPorValor(formId: string, value: string): Observable<any> {
    return this.api.GetDefinicoesFormPorValor(formId, value);
  }

  public CriarOpcaoForm(signature: OpcaoFormSignature): Observable<any> {
    return this.api.CriarOpcaoForm(signature);
  }

  public AtualizarOpcaoForm(signature: OpcaoFormSignature): Observable<any> {
    return this.api.AtualizarOpcaoForm(signature);
  }

  public DeletarOpcaoForm(id: string): Observable<any> {
    return this.api.DeletarOpcaoForm(id);
  }
} 